








import Vue from 'vue';
import { PricePlan, PricePlansTableElement } from '@/types';
import AddPricePlanBtn from './AddPricePlanBtn.vue';
import PricePlansTable from './PricePlansTable.vue';

export default Vue.extend({
  meta: {
    title: 'Price Plans',
  },
  methods: {
    add(pricePlan: PricePlan): void {
      (this.$refs.pricePlansTable as PricePlansTableElement).add(pricePlan);
    },
  },
  components: {
    'add-price-plan-btn': AddPricePlanBtn,
    'price-plans-table': PricePlansTable,
  },
});
